<div [@slideInTopOpenClose]="field.hide ? 'close' : 'open'">
  <ng-container #fieldComponent></ng-container>
</div>
